<template>
  <header class="company-page-heading user-requests-heading">
    <div>
      <h1 :id="titleId">{{ title }}</h1>
      <span class="user-requests-count" aria-live="polite">{{ count }}</span>
    </div>
  </header>
</template>

<script>
export default {
  name: "CompanyPageHeading",
  props: {
    title: {
      type: String,
      required: true,
    },
    titleId: {
      type: String,
      default: "company-page-title",
    },
    count: {
      type: [Number, String],
      required: true,
    },
  },
};
</script>

<style scoped>
.user-requests-heading {
  margin-bottom: 24px;
}

.user-requests-heading > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-requests-heading h1 {
  margin: 0;
  color: var(--request-text);
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
}

.user-requests-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  border-radius: 20px;
  background: rgba(62, 65, 109, 0.1);
  color: var(--request-primary);
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

@media (max-width: 767px) {
  .user-requests-heading {
    margin-bottom: 16px;
  }

  .user-requests-heading h1 {
    font-size: 24px;
  }
}
</style>
